// extracted by mini-css-extract-plugin
module.exports = {"dots":"Loading_dots__2zhvy","dot1":"Loading_dot1__14SQD","load":"Loading_load__30HqA","dot2":"Loading_dot2__3goZZ","dot3":"Loading_dot3__2OAac"};